const set = require('regenerate')(0xB7, 0x300, 0x307, 0x2E17);
set.addRange(0x304, 0x305).addRange(0x374, 0x375).addRange(0x3E2, 0x3EF).addRange(0x2C80, 0x2CF3).addRange(0x2CF9, 0x2CFF).addRange(0x102E0, 0x102FB);
exports.characters = set;
